import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/core'
import { useStyles } from './Dente.styles'

export const Dente = (props) => {
  const { identificador, dente, setDente } = props
  const classes = useStyles()
  const theme = useTheme()
  const [hoverPath, setHoverPath] = useState(null)

  const isDark = theme.palette.type === 'dark'

  // Dynamic Theme Colors for the Tooth SVG
  const colorActive = theme.palette.primary.main
  const colorActiveHover = theme.palette.primary.light
  const colorInactive = isDark ? '#2C2E33' : '#E2E8F0'
  const colorInactiveHover = isDark ? '#3E414B' : '#CBD5E1'

  const colorAusente = isDark ? '#09090B' : '#475569'
  const colorAusenteHover = isDark ? '#18181B' : '#334155'
  const colorStroke = isDark ? '#4A4D56' : '#94A3B8'

  const alterarCampo = (campo, valor) => {
    setDente(identificador, {
      ...dente,
      identificador,
      [campo]: valor,
    })
  }

  const selecionarParteDente = (campo) => {
    alterarCampo(campo, !dente[campo])
  }

  const alterarAusente = () => {
    setDente(identificador, {
      ...dente,
      identificador,
      ausente: !dente.ausente,
      faceDistal: false,
      faceLingual: false,
      faceMesial: false,
      faceVestibular: false,
    })
  }

  const getColor = (id) => {
    if (dente.ausente) {
      return isDark ? '#18191C' : '#F1F5F9' // Muted background for absent tooth faces
    }

    const ativo = dente[`face${id.charAt(0).toUpperCase() + id.slice(1)}`]

    if (ativo) {
      return hoverPath === id ? colorActiveHover : colorActive
    }

    return hoverPath === id ? colorInactiveHover : colorInactive
  }

  const getColorAusente = () => {
    if (dente.ausente) {
      return hoverPath === 'centro' ? colorAusenteHover : colorAusente
    }
    return hoverPath === 'centro' ? colorInactiveHover : colorInactive
  }

  return (
    <div className={classes.root}>
      <div className={classes.svgWrapper}>
        <svg width="58" height="82" viewBox="0 0 58 82">
          {/* Centro (Ausência) */}
          <path
            d="M16.2842 70.0306V50.0306H41.2842V70.0306H16.2842Z"
            fill={getColorAusente()}
            onMouseEnter={() => setHoverPath('centro')}
            onMouseLeave={() => setHoverPath(null)}
            onClick={alterarAusente}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Distal */}
          <path
            d="M16.2842 70.0306L0.784241 81.0306V38.5306L16.2842 50.0306V70.0306Z"
            fill={getColor('distal')}
            onMouseEnter={() => setHoverPath('distal')}
            onMouseLeave={() => setHoverPath(null)}
            onClick={() => selecionarParteDente('faceDistal')}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Lingual */}
          <path
            d="M56.2842 38.5306H0.784241L16.2842 50.0306H41.2842L56.2842 38.5306Z"
            fill={getColor('lingual')}
            onMouseEnter={() => setHoverPath('lingual')}
            onMouseLeave={() => setHoverPath(null)}
            onClick={() => selecionarParteDente('faceLingual')}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Mesial */}
          <path
            d="M56.2842 38.5306L41.2842 50.0306V70.0306L56.2842 81.0306V38.5306Z"
            fill={getColor('mesial')}
            onMouseEnter={() => setHoverPath('mesial')}
            onMouseLeave={() => setHoverPath(null)}
            onClick={() => selecionarParteDente('faceMesial')}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Vestibular */}
          <path
            d="M16.2842 70.0306L0.784241 81.0306H56.2842L41.2842 70.0306H16.2842Z"
            fill={getColor('vestibular')}
            onMouseEnter={() => setHoverPath('vestibular')}
            onMouseLeave={() => setHoverPath(null)}
            onClick={() => selecionarParteDente('faceVestibular')}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Identificador Círculo */}
          <circle
            cx="30"
            cy="15"
            r="14"
            fill={theme.palette.background.paper}
            stroke={colorStroke}
            strokeWidth="1"
          />

          {/* Identificador Texto */}
          <text
            x="30.2842"
            y="14.5"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="10"
            fontWeight="bold"
            fill={theme.palette.text.primary}
          >
            {identificador}
          </text>
        </svg>
      </div>
    </div>
  )
}

Dente.propTypes = {
  identificador: PropTypes.string.isRequired,
  dente: PropTypes.shape({
    ausente: PropTypes.bool,
    faceDistal: PropTypes.bool,
    faceLingual: PropTypes.bool,
    faceMesial: PropTypes.bool,
    faceVestibular: PropTypes.bool,
  }).isRequired,
  setDente: PropTypes.func.isRequired,
}
